// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"3705d202","80":"601f6191","140":"3705d202","365":"d03d3950","514":"3705d202","640":"1856a2a3","664":"3705d202","729":"30e47766"}[chunkId] + ".chunk.css";
};